import CustomerModel from '../../../models/stripe/Customer';
import HttpReference from '../../platform/HttpReference';
import Customers from './Customers';

export default class Customer extends HttpReference<CustomerModel, void, Customers> {}
